var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeBenefits(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5522 18.7956C21.5522 20.6078 20.083 22.077 18.2708 22.077C16.4586 22.077 14.9893 20.6078 14.9893 18.7956C14.9893 16.9834 16.4586 15.5142 18.2708 15.5142C20.083 15.5142 21.5522 16.9834 21.5522 18.7956Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1304 29.7275V27.1447C24.1304 26.3196 23.4705 25.6431 22.6635 25.6431H13.8775C13.0714 25.6431 12.4107 26.3196 12.4107 27.1447V29.7275",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2672 19.0225C28.2672 20.1511 27.3528 21.0655 26.2243 21.0655C25.0965 21.0655 24.1821 20.1511 24.1821 19.0225C24.1821 17.8939 25.0965 16.9795 26.2243 16.9795C27.3528 16.9795 28.2672 17.8939 28.2672 19.0225Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8722 26.3901V24.7826C29.8722 24.2681 29.4613 23.8477 28.9594 23.8477H24.6577",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79797 19.0225C7.79797 20.1511 8.71237 21.0655 9.84016 21.0655C10.9687 21.0655 11.8831 20.1511 11.8831 19.0225C11.8831 17.8939 10.9687 16.9795 9.84016 16.9795C8.71237 16.9795 7.79797 17.8939 7.79797 19.0225Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19258 26.3901V24.7826C6.19258 24.2681 6.60355 23.8477 7.10619 23.8477H11.4071",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0324 5.6001L19.0092 7.57907L21.1937 7.89678L19.6131 9.43711L19.9861 11.6129L18.0324 10.5862L16.0787 11.6129L16.4518 9.43711L14.8711 7.89678L17.0556 7.57907L18.0324 5.6001Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84056 9.31494L10.4704 10.5913L11.8804 10.7968L10.8609 11.7902L11.1011 13.1938L9.84056 12.5308L8.57999 13.1938L8.82104 11.7902L7.80153 10.7968L9.21067 10.5913L9.84056 9.31494Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2243 9.31494L26.8541 10.5913L28.2641 10.7968L27.2438 11.7902L27.4848 13.1938L26.2243 12.5308L24.9637 13.1938L25.2047 11.7902L24.1852 10.7968L25.5944 10.5913L26.2243 9.31494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeBenefits);
export default __webpack_public_path__ + "static/media/Employee Benefits.24b16873fc21e2000e8962a9b6bb216a.svg";
export { ForwardRef as ReactComponent };